import { all, fork } from 'redux-saga/effects';

import { dashboardSaga } from './Dashboard';
import { billingSaga } from './Billing';
import { billingDetailsSaga } from './BillingDetails';
import { passwordSaga } from './Password';
import { mobileNumberPageSaga } from './MobileNumberPage';
import { policySaga } from './Policy';
import { otpLinkSaga } from './OtpLink';
import { claimSaga } from './Claim';
import { ClaimDetailsSaga } from './ClaimDetails';
import { claimEditSaga } from './ClaimEdit';
import { userClaimAdditionalDocumentsSaga } from './ClaimAdditionalDocuments';
import { PolicyClaimSaga } from './PolicyClaim';
import { policyDetailsSaga } from './PolicyDetails';
import { policyRenewalSaga } from './PolicyRenewal';
import { VehicleSaga } from './Vehicle';
import { VehicleDetailsSaga } from './VehicleDetails';
import { VehicleFormSaga } from './VehicleForm';
import { DocumentSaga } from './Document';
import { DocumentNewSaga } from './DocumentNew';
import { DocumentDetailsSaga } from './DocumentDetails';
import { DocumentEditSaga } from './DocumentEdit';
import { personalInfoEditSaga } from './PersonalInfoEditPage';
import { searchCorporateMemberSaga } from './SearchCorporateMember';
import { insurancePolicyListPageSaga } from './InsurancePolicyListPage';
import { insurancePolicyDetailsPageSaga } from './InsurancePolicyDetailsPage';
import { commissionListSaga } from './CommissionList';

export default function* () {
  yield all([
    fork(dashboardSaga),
    fork(billingSaga),
    fork(billingDetailsSaga),
    fork(passwordSaga),
    fork(mobileNumberPageSaga),
    fork(personalInfoEditSaga),
    fork(policySaga),
    fork(claimSaga),
    fork(ClaimDetailsSaga),
    fork(userClaimAdditionalDocumentsSaga),
    fork(PolicyClaimSaga),
    fork(policyDetailsSaga),
    fork(policyRenewalSaga),
    fork(VehicleSaga),
    fork(VehicleDetailsSaga),
    fork(VehicleFormSaga),
    fork(DocumentSaga),
    fork(DocumentNewSaga),
    fork(DocumentDetailsSaga),
    fork(DocumentEditSaga),
    fork(otpLinkSaga),
    fork(claimEditSaga),
    fork(searchCorporateMemberSaga),
    fork(insurancePolicyListPageSaga),
    fork(insurancePolicyDetailsPageSaga),
    fork(commissionListSaga)
  ]);
}
